exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".lista-horizontal {\r\n    display: inline-block;\r\n    flex-wrap: wrap;\r\n    list-style-type: none;\r\n}\r\n\r\n.item-aplicacion .item-titulo {\r\n    color: #000000; /* Cambiado a azul oscuro */\r\n}\r\n\r\n.item-icono-app {\r\n    color: #004d9b; /* Azul oscuro para mantener consistencia */\r\n    padding-right: 8px;\r\n}\r\n\r\n.item-apl-titulo {\r\n    color: #000000; /* Azul oscuro */\r\n    text-decoration: none;\r\n    display: block;\r\n    padding: 6px 10px;\r\n    border-radius: 4px;\r\n}\r\n\r\n.item-apl-titulo:hover {\r\n    transition: color 0.2s ease, background-color 0.2s ease;\r\n    color: #002e66; /* Azul más oscuro al hacer hover */\r\n    background-color: #f5f5f5;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/portal/components/contenedor-aplicaciones/item-aplicacion/item-aplicacion.style.css
// module id = 635
// module chunks = 0